var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinStackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 10.25C13.3332 11.8608 10.7215 13.1667 7.49984 13.1667C4.27818 13.1667 1.6665 11.8608 1.6665 10.25M13.3332 10.25C13.3332 8.63917 10.7215 7.33333 7.49984 7.33333C4.27818 7.33333 1.6665 8.63917 1.6665 10.25M13.3332 10.25V14.9167M1.6665 10.25V14.9167M20.3332 4.41667C20.3332 2.80584 17.7215 1.5 14.4998 1.5C12.1909 1.5 10.1953 2.17075 9.24984 3.1438M20.3332 4.41667C20.3332 5.49625 19.1601 6.43883 17.4165 6.94314M20.3332 4.41667V14.3333C20.3332 15.197 19.1601 15.9511 17.4165 16.3545M20.3332 9.66667C20.3332 10.5495 19.1075 11.3178 17.2998 11.7141M13.3332 14.9167C13.3332 16.5275 10.7215 17.8333 7.49984 17.8333C4.27818 17.8333 1.6665 16.5275 1.6665 14.9167M13.3332 14.9167V19.5833C13.3332 21.1942 10.7215 22.5 7.49984 22.5C4.27818 22.5 1.6665 21.1942 1.6665 19.5833V14.9167",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStackIcon);
export default __webpack_public_path__ + "static/media/coinStackIcon.ae2072f25737b9573a89f0c4f2d4451d.svg";
export { ForwardRef as ReactComponent };